$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
templates = require 'app/scripts/views/internal/templates'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ trackUe, Noun, Verb } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'

module.exports = class OverdueBannerView extends WarningBannerView
  className: Util.extendParentClassName('overdue-banner')

  events:
    'click .js-update-billing-information': 'updateBillingInformation'
    'click .js-dismiss-overdue-banner': 'dismiss'

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  getMessageName: ->
    paidAccount = @model.get('paidAccount')
    billingDate = new Date(paidAccount.billingDates?[paidAccount.products?[0]]).getTime()
    "OverdueBanner-#{@model.id}-#{billingDate}"

  render: ->
    trackUe({
      category: Noun.OVERDUE_BANNER,
      verb: Verb.SHOWS,
      directObj: Noun.UPDATE_PAYMENT_METHOD_PROMPT,
      context: {
        ixSubscriber: @model.get('paidAccount')?.ixSubscriber,
        teamId: @model?.id,
        isTeamAdmin: true
      }
    })
    if @sendGASEvent
      Analytics.sendScreenEvent
        name: 'overdueBanner'
        containers:
          organization:
            id: @model?.id || ''
        attributes:
          isTeamAdmin: true
          ixSubscriber: @model.get('paidAccount')?.ixSubscriber

    data =
      team: @model.get('displayName')
      billingUrl: Controller.getOrganizationBillingUrl(@model)
    @$el.html templates.fill('header_overdue_banner', data)

    @

  updateBillingInformation: ->
    trackUe({
      category: Noun.OVERDUE_BANNER,
      verb: Verb.OPENS,
      directObj: Noun.BILLING_PAGE,
      method: 'by clicking banner link',
      context: {
        ixSubscriber: @model.get('paidAccount')?.ixSubscriber,
        teamId: @model?.id,
        isTeamAdmin: true
      }
    })
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'link'
        actionSubjectId: 'updateBillingInfoLink'
        source: 'overdueBanner'
        containers:
          organization:
            id: @model?.id || ''
        attributes:
          isTeamAdmin: true
          ixSubscriber: @model.get('paidAccount')?.ixSubscriber

  dismiss: (e) ->
    trackUe({
      category: Noun.OVERDUE_BANNER,
      verb: Verb.DISMISSES,
      directObj: Noun.OVERDUE_BANNER,
      method: 'by clicking dismiss button',
      context: {
        ixSubscriber: @model.get('paidAccount')?.ixSubscriber,
        teamId: @model?.id,
        isTeamAdmin: true
      }
    })
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'dismissed'
        actionSubject: 'banner'
        source: 'overdueBanner'
        containers:
          organization:
            id: @model?.id || ''
        attributes:
          isTeamAdmin: true
          ixSubscriber: @model.get('paidAccount')?.ixSubscriber

    Auth.me().dismiss @getMessageName()
    $('.overdue-banner').remove()
    e.preventDefault()
